<template>
  <div>
    Message:
    <ckeditor
      v-model="valueLocal"
      :editor="editor"
      :config="editorConfig"
      clearable
      @input="change"
    ></ckeditor>
  </div>
</template>

<script>
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import CKEditor from "@ckeditor/ckeditor5-vue2";

/**
 * https://github.com/hifarer/vueditor?tab=readme-ov-file
 */
export default {
  components: {
    ckeditor: CKEditor.component,
  },
  props: {
    value: { type: String },
  },
  mounted() {},
  data() {
    return {
      editor: ClassicEditor,
      valueLocal: this.value, // Lega il valore locale al prop
      //questa configurazione era valida per ckEditor4 
      // editorConfig: {
      //   allowedContent: true,
      //   enterMode: 1,
      //   autoParagraph: false,
      //   fillEmptyBlocks: false,
      //   height: 250,
      //   format_tags: "p;h1;h2;h3;h4;h5;h6;pre;address;div",
      //   indent: false,
      //   breakAfterOpen: false,
      //   ignoreEmptyParagraph: true,
      //   removePlugins: "enterkey,entities",
      //   toolbar: [
      //     [
      //       "Format",
      //       "Bold",
      //       "Italic",
      //       "Underline",
      //       "-",
      //       "NumberedList",
      //       "BulletedList",
      //     ],
      //     ["Link", "Unlink"],
      //     ["-", "SelectAll", "Source"],
      //   ],
      // },
      editorConfig: {
      // La configurazione per CKEditor 5
      toolbar: [
        "heading", "bold", "italic", "underline", "|", "link", "bulletedList", "numberedList", "|", "undo", "redo"
      ],
      height: 250,
      language: 'it',
      enterMode: 'p', 
      removePlugins: ["Image", "Table", "MediaEmbed","CKFinder"],
      heading: {
        options: [
          { model: 'paragraph', title: 'Normal', class: 'ck-heading_paragraph' },
          { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
          { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
          { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
          { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
          { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
          { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' }
        ]
      },
    },
    };
  },
  watch: {
    value(newVal) {
      this.valueLocal = newVal; // Aggiorna il valore locale se cambia il prop
    },
  },
  methods: {
    change() {
      this.$emit('input', this.valueLocal.replace(/\n|\r/g, ""))
    },
  },
};
</script>

<style></style>
